<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<h2 mat-dialog-title>
  Drop / Junk
  <img class="close-button" (click)="onNoClick()" src="/assets/images/close.png" alt="">
</h2>
<mat-dialog-content>
  <form [formGroup]="lostjunkForm" class="lost-junk-form">
    <div class="form-content">
      <!-- Toggle button for Lost/Junk -->
      <div class="formInput mb-3">
        <label class="form-label">Select Option:</label>
        <div class="btn-group-toggle">
          <label class="btn" [class.active]="reasonType === 'lost'" (click)="reasonType = 'lost';setForm('lost');">
            <input type="radio" name="reasonType" [value]="'lost'" (click)="reasonType = 'lost';setForm('lost');"> Drop
          </label>
          <label class="btn" [class.active]="reasonType === 'junk'" (click)="reasonType = 'junk';setForm('junk');">
            <input type="radio" name="reasonType" [value]="'junk'" (click)="reasonType = 'junk';setForm('junk');"> Junk
          </label>
        </div>
      </div>

      <!-- Lost Reason Dropdown -->
      <div class="formInput" *ngIf="reasonType === 'lost'">
        <label class="form-label">Drop Reasons<span class="alert-small">*</span></label>
        <select class="form-select" formControlName="lost_reason" [attr.value]="lostjunkForm.get('lost_reason')?.value"
          [ngClass]="{ 'is-invalid': submitted && f['lost_reason'].errors }" (change)="onDropChange($event)">
          <option disabled selected value="">Select</option>
          <option *ngFor="let lost of preSalesLostReason" [value]="lost.id + ':' + lost.reason">{{ lost.reason }}
          </option>
        </select>
        <div *ngIf="submitted && f['lost_reason'].errors" class="invalid-feedback">
          <div *ngIf="lostjunkForm.get('lost_reason')?.errors?.['required']" class="error-msg">
            Please select drop reason.
          </div>
        </div>
      </div>

      <!-- Junk Reason Dropdown -->
      <div class="formInput" *ngIf="reasonType === 'junk'">
        <label class="form-label">Junk Reasons<span class="alert-small">*</span></label>
        <select class="form-select" formControlName="junk_reason" [attr.value]="lostjunkForm.get('junk_reason')?.value"
          [ngClass]="{ 'is-invalid': submitted && f['junk_reason'].errors }">
          <option disabled selected value="">Select</option>
          <option *ngFor="let junk of junkReason" [value]="junk.id + ':' + junk.reason">{{ junk.reason }}</option>
        </select>
        <div *ngIf="submitted && f['junk_reason'].errors" class="invalid-feedback">
          <div *ngIf="lostjunkForm.get('junk_reason')?.errors?.['required']" class="error-msg">
            Please select junk reason.
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <ng-container *ngIf="!isAddEnabled">
          <div class="col-10">
            <div class="formInput" *ngIf="isDrop && dropReasonId == 4">
              <label class="form-label">Brand <span class="alert-small">*</span></label>
              <select class="form-select" formControlName="brand" [attr.value]="lostjunkForm.get('brand')?.value"
                [ngClass]="{ 'is-invalid': submitted && f['brand'].errors }">
                <option disabled selected value="">Select Brand</option>
                <option *ngFor="let data of brandList" [value]="data.brand">{{ data.brand }}</option>
              </select>
              <div *ngIf="submitted && f['brand'].errors" class="invalid-feedback">
                <div *ngIf="lostjunkForm.get('brand')?.errors?.['required']" class="error-msg">
                  Please select brand.
                </div>
              </div>
            </div>
          </div>
          <div class="col-2 mt-4" style="padding-top:12px" *ngIf="isDrop && dropReasonId == 4">
            <img src="/assets/images/plus.png" style="width: 24px;cursor: pointer;" alt="" (click)="addEnable()">
          </div>
        </ng-container>
        <ng-container *ngIf="isAddEnabled">
          <div class="col-10">
            <div class="formInput" *ngIf="isDrop && dropReasonId == 4">
              <label class="form-label">Brand <span class="alert-small">*</span></label>
              <input type="text" class="form-control"  formControlName="brand" maxlength="35" placeholder="Enter a brand name" (keypress)="restrictFirstLetterSpace($event);allwoAlphabetsOnly($event)" [(ngModel)]="newBrandName"
              [ngClass]="{ 'is-invalid': submitted && f['brand'].errors }">
              <div *ngIf="submitted && f['brand'].errors" class="invalid-feedback">
                <div *ngIf="lostjunkForm.get('brand')?.errors?.['required']" class="error-msg">
                  Brand is required.
                </div>
              </div>
            </div>
          </div>
          <div class="col-2 mt-4" style="padding-top:14px" *ngIf="isDrop && dropReasonId == 4">
            <mat-icon class="cross-icon mr-2" title="Cancel" (click)="closeAdd()">close</mat-icon>
            <!-- <mat-icon class="tick-icon" title="Save" (click)="saveBrand()">check</mat-icon> -->
          </div>
        </ng-container>
      </div>
      <div class="row mb-2">
        <div class="col">
          <div class="formInput" *ngIf="isDrop && dropReasonId == 4">
            <label class="form-label">Model</label>
            <input type="text" class="form-control" maxlength="50" placeholder="Enter model name" (keypress)="restrictFirstLetterSpace($event)" formControlName="model">
          </div>
        </div>
      </div>
      <!-- Remarks Textarea -->
      <div class="mb-3">
        <label for="remarks" class="form-label">Remarks</label>
        <textarea class="form-control" formControlName="remarks" id="remarks" rows="3"
          [attr.value]="lostjunkForm.get('remarks')?.value" placeholder="Enter text here"></textarea>
      </div>
    </div>
  </form>
</mat-dialog-content>
<!-- Dialog Actions -->
<div mat-dialog-actions class="d-flex justify-content-end">
  <button class="btn white-btn mr-2" (click)="onNoClick()">Cancel</button>
  <button class="btn blue-btn mr-3" (click)="onSubmit()" type="submit">Submit</button>
</div>